import React from 'react';
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider, withTheme } from '@material-ui/core/styles';
import MaterialTable from 'material-table';

import Clear from "@material-ui/icons/Clear";
import Add from "@material-ui/icons/Add";
import Check from "@material-ui/icons/Check";
import Delete from "@material-ui/icons/DeleteOutline";
import DetailPanel from "@material-ui/icons/ChevronRight";
import Edit from "@material-ui/icons/Edit";
import Export from "@material-ui/icons/SaveAlt";
import Filter from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import NextPage from "@material-ui/icons/ChevronRight";
import PreviousPage from "@material-ui/icons/ChevronLeft";
import ResetSearch from "@material-ui/icons/Clear";
import Search from "@material-ui/icons/Search";
import ThirdStateCheck from "@material-ui/icons/Remove";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Replay from "@material-ui/icons/Replay";

const tableIcons = {
    Add: () => <Add/>,
    Check: () => <Check/>,
    Clear: () => <Clear/>,
    Delete: () => <Delete/>,
    DetailPanel: () => <DetailPanel/>,
    Edit: () => <Edit/>,
    Export: () => <Export/>,
    Filter: () => <Filter/>,
    FirstPage: () => <FirstPage/>,
    LastPage: () => <LastPage/>,
    NextPage: () => <NextPage/>,
    PreviousPage: () => <PreviousPage/>,
    ResetSearch: () => <ResetSearch/>,
    Search: () => <Search/>,
    ThirdStateCheck: () => <ThirdStateCheck/>,
    ViewColumn: () => <ViewColumn/>,
    Replay: () => <Replay/>,
}

/*const columns=[
    { name: 'ID', options: {filter: false, sort: true,}},
    { name: 'Name', options: {filter: false, sort: true,}},
    { name: 'Address', options: {filter: false, sort: true,}},
    { name: 'Sex', options: {filter: true, sort: true,}},
    { name: 'DOB', options: {filter: false, sort: true,}},
    { name: 'Scheme', options: {filter: true, sort: true,}},
    { name: 'Dentist', options: {filter: true, sort: true,}},
];*/  

const theme = createMuiTheme({
    overrides: {
        MuiTableCell: {
            root: {
                padding: 1,
                paddingLeft: 5,
            },
        },
        /*MuiPaper: {
            elevation4: {
                boxShadow: 'none',
            },
        },
        MUIDataTable: {
            responsiveScroll: {
                paddingLeft: 8,
                maxHeight: `calc(100vh - 145px)`,
            },
        },*/

    }
  });

/*const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
      height: '100vh',
  }
});*/

class PatientSearchResults extends React.Component {
    _isMounted = false;

  state = {
    order: 'asc',
    orderBy: 'patient_id',
    selected: [],
    data: [],
    page: 0,
    rowsPerPage: 100,
  };

  constructor(props){
    super(props);
    this.props = props;
    this.searchstring = props.match.params.searchstring;
  };

  componentDidMount(){
    this._isMounted = true;
      this.props.socket.on("patient_search_result",(d)=>{
            let tempdata = [];
            let i = 0;

            if (this._isMounted) {
                
                let data = d.map((dt, i) => {
                    let addr = [];
                    let addrdisplay = '';                    
                    let row = {};

                    if (dt.address1)
                        addr.push(dt.address1);
                    if (dt.address2)
                        addr.push(dt.address2);
                    if (dt.postcode)
                        addr.push(dt.postcode);

                    addrdisplay = addr.join(', ');

                    row.patient_id = dt.patient_id;
                    row.patientname = dt.patientname;
                    row.title = dt.title;
                    row.forenames = dt.forenames;
                    row.surname = dt.surname;
                    row.address = addrdisplay;
                    row.sex = dt.sex;
                    row.dob = dt.dob;
                    row.scheme = dt.scheme_ld;
                    row.dentist = dt.displayname;

                    return row;
                });

                /*for (i = 0; i < d.length; i++)
                {
                    addr = [];
                    addrdisplay = '';

                    if (d[i].address1)
                        addr.push(d[i].address1);
                    if (d[i].address2)
                        addr.push(d[i].address2);
                    if (d[i].postcode)
                        addr.push(d[i].postcode);

                    addrdisplay = addr.join(', ');

                    tempdata.push([d[i].patient_id, d[i].patientname, addrdisplay, d[i].sex, d[i].dob, d[i].scheme_ld, d[i].displayname]);
                }*/



                this.setState({data:data});

            }
      })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleDoubleClick = (event, selectedRow) => {
    //console.log(event);
    //console.log(selectedRow);
    this.props.history.push('/patient/'+selectedRow.patient_id);
    this.props.parentstate.state.searches.push({name:selectedRow.patientname,id:selectedRow.patient_id});
    /*this.props.parentstate.setState({currentPatientNameText:selectedRow.patientname});
    this.props.parentstate.setState({currentPatientSecondLine:"ID "+selectedRow.patient_id+" - "+selectedRow.sex+ " - "+selectedRow.dob});
    this.props.parentstate.setState({currentPatientThirdLine:event[6]+" - Scheme: "+selectedRow.scheme});
    this.props.parentstate.setState({currentpatient:selectedRow.patient_id});*/
  };

  render() {
    const { data } = this.state;

    const columns=[
        { title: 'ID', field: 'patient_id', filtering: false},
        { title: 'Title', field: 'title'},
        { title: 'Forenames', field: 'forenames'},
        { title: 'Surname', field: 'surname'},
        { title: 'Address', field: 'address'},
        { title: 'Sex', field: 'sex'},
        { title: 'DOB', field: 'dob'},
        { title: 'Scheme', field: 'scheme'},
        { title: 'Dentist', field: 'dentist'}
    ];      

    const options = {
        filterType: "dropdown",
        responsive: "standard",
        selectableRows: false,
        pagination: false,
        textLabels: {
            body: {
              noMatch: "No patient records found!",
            },
        },
        onClick: this.handleDoubleClick,
    }

    return (
        <div>
            <MuiThemeProvider theme={theme}>
                <MaterialTable
                    data={data}
                    columns={columns}
                    title="Patient Results"
                    options={{
                        exportButton: true,
                        selection: false,
                        filtering: false,
                        pageSize: 20,
                    }}
                    onRowClick={this.handleDoubleClick}
                    icons={tableIcons}
                />
            </MuiThemeProvider>   
        </div>
    );
  }
}

PatientSearchResults.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default PatientSearchResults;